import { render, staticRenderFns } from "./sys_dictvalue.vue?vue&type=template&id=f5f8de08&scoped=true&"
import script from "./sys_dictvalue.vue?vue&type=script&lang=js&"
export * from "./sys_dictvalue.vue?vue&type=script&lang=js&"
import style0 from "./sys_dictvalue.vue?vue&type=style&index=0&id=f5f8de08&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f8de08",
  null
  
)

export default component.exports